import { clearInputForm } from "./input";
import { hideSuccessMessage, setLoadingState } from "./styles";
import { resetErrorMessages } from "./errors";
import Modal from "../common/classes/modal";

const contactForm = document.querySelector(".contact-form");
const successMessage = document.querySelector(".success-message");

const toggleContactUsModal = () => {
  contactForm.classList.toggle("form-feedback");
};

const modal = new Modal({
  elementId: "feedback-modal",
  onOpenCallback: () => {
    toggleContactUsModal();
  },
  onCloseCallback: () => {
    toggleContactUsModal();
    clearInputForm();
    resetErrorMessages();

    if (successMessage.getAttribute("data-success") === "true") {
      hideSuccessMessage();
      setLoadingState(false);
    }
  },
});

const openContactUsModal = ({ callback = () => {} } = {}) => {
  modal.open(() => {
    callback();
  });
};

export default openContactUsModal;
